import { Container, Row, Col, Image, Navbar } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ApiUtil from "../util/ApiUtil";
import ApiPath from "../util/ApiPath";
import SessionUtil from "../util/SessionUtil";
import { useCallback, useEffect, useState } from "react";
import ReactLoading from "react-loading";

function TermsConditionsPrivacyPolicyView({ page, type }) {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const lang = SessionUtil.getLang();
  const getApi = useCallback(async () => {
    setLoading(true);
    let data = {
      TermsAndConditionsView: {
        EntityName:
          page === "store"
            ? "STORES"
            : page === "driver"
            ? "DRIVERS"
            : page === "user"
            ? "USERS"
            : "",
      },
    };
    const res = await ApiUtil.postApi(
      ApiPath.GET_TERMS_AND_CONDITIONS,
      data,
      "POST"
    );
    if (res.IsSuccessfull) {
      if (res.Result.TermsAndConditions.length > 0)
        setData(res.Result.TermsAndConditions[0]);
      setLoading(false);
    }
  }, [page]);
  useEffect(() => {
    getApi();
  }, [getApi]);

  return (
    <>
      <Navbar>
        <Container
          className="bg-navbar p-3 rounded mx-4 mx-xxl-auto shadow-sm gap-3"
          fluid="xxl"
        >
          <Navbar.Brand href="#">
            <Image alt="image" src={"/images/logo.png"} />
          </Navbar.Brand>
        </Container>
      </Navbar>
      <Container className="px-4 mt-2" fluid="xxl">
        <Row>
          <Col xs={12}>
            <div className=" mt-4">
              <p className="title">
                {type === "TermsConditions"
                  ? t("Terms and Conditions")
                  : t("Privacy Policy")}
              </p>
            </div>
          </Col>

          {!loading ? (
            <Col>
            {type === "TermsConditions" ?
              <div
                dangerouslySetInnerHTML={{
                  __html:
                    lang === "en" || data.TermsAndConditionsAr === ""
                      ? data.TermsAndConditionsEn
                      : data.TermsAndConditionsAr,
                }}
              /> :  <div
              dangerouslySetInnerHTML={{
                __html:
                  lang === "en" || data.PrivacyPolicyAr === ""
                    ? data.PrivacyPolicyEn
                    : data.PrivacyPolicyAr,
              }}
            />
              }
            </Col>
          ) : (
            <Col lg={12} className="loading-style">
              <ReactLoading
                type={"bars"}
                color={"#c8c8c8"}
                height={"50px"}
                width={"50px"}
              />
            </Col>
          )}
        </Row>
      </Container>
    </>
  );
}
export default TermsConditionsPrivacyPolicyView;
